<div class="switch-filter" [attr.title]="tooltip || null">
    <pf-switch [label]="filterName" [control]="checkedControl"></pf-switch>
</div>
